export default [
  { code: "+93", label: "AF" },
  { code: "+355", label: "AL" },
  { code: "+213", label: "DZ" },
  { code: "+1", label: "AS" },
  { code: "+376", label: "AD" },
  { code: "+244", label: "AO" },
  { code: "+1", label: "AI" },
  { code: "+672", label: "AQ" },
  { code: "+1", label: "AG" },
  { code: "+54", label: "AR" },
  { code: "+374", label: "AM" },
  { code: "+297", label: "AW" },
  { code: "+61", label: "AU" },
  { code: "+43", label: "AT" },
  { code: "+994", label: "AZ" },

  { code: "+1", label: "BS" },
  { code: "+973", label: "BH" },
  { code: "+880", label: "BD" },
  { code: "+1", label: "BB" },
  { code: "+375", label: "BY" },
  { code: "+32", label: "BE" },
  { code: "+501", label: "BZ" },
  { code: "+229", label: "BJ" },
  { code: "+1", label: "BM" },
  { code: "+975", label: "BT" },
  { code: "+591", label: "BO" },
  { code: "+387", label: "BA" },
  { code: "+267", label: "BW" },
  { code: "+55", label: "BR" },
  { code: "+246", label: "IO" },
  { code: "+673", label: "BN" },
  { code: "+359", label: "BG" },
  { code: "+226", label: "BF" },
  { code: "+257", label: "BI" },

  { code: "+855", label: "KH" },
  { code: "+237", label: "CM" },
  { code: "+1", label: "CA" },
  { code: "+238", label: "CV" },
  { code: "+1", label: "KY" },
  { code: "+236", label: "CF" },
  { code: "+235", label: "TD" },
  { code: "+56", label: "CL" },
  { code: "+86", label: "CN" },
  { code: "+57", label: "CO" },
  { code: "+269", label: "KM" },
  { code: "+242", label: "CG" },
  { code: "+243", label: "CD" },
  { code: "+682", label: "CK" },
  { code: "+506", label: "CR" },
  { code: "+225", label: "CI" },
  { code: "+385", label: "HR" },
  { code: "+53", label: "CU" },
  { code: "+357", label: "CY" },
  { code: "+420", label: "CZ" },

  { code: "+45", label: "DK" },
  { code: "+253", label: "DJ" },
  { code: "+1", label: "DM" },
  { code: "+1", label: "DO" },

  { code: "+593", label: "EC" },
  { code: "+20", label: "EG" },
  { code: "+503", label: "SV" },
  { code: "+240", label: "GQ" },
  { code: "+291", label: "ER" },
  { code: "+372", label: "EE" },
  { code: "+251", label: "ET" },

  { code: "+500", label: "FK" },
  { code: "+298", label: "FO" },
  { code: "+679", label: "FJ" },
  { code: "+358", label: "FI" },
  { code: "+33", label: "FR" },

  { code: "+241", label: "GA" },
  { code: "+220", label: "GM" },
  { code: "+995", label: "GE" },
  { code: "+49", label: "DE" },
  { code: "+233", label: "GH" },
  { code: "+350", label: "GI" },
  { code: "+30", label: "GR" },
  { code: "+299", label: "GL" },
  { code: "+1", label: "GD" },
  { code: "+502", label: "GT" },
  { code: "+224", label: "GN" },
  { code: "+245", label: "GW" },
  { code: "+592", label: "GY" },

  { code: "+509", label: "HT" },
  { code: "+504", label: "HN" },
  { code: "+852", label: "HK" },
  { code: "+36", label: "HU" },

  { code: "+354", label: "IS" },
  { code: "+91", label: "IN" },
  { code: "+62", label: "ID" },
  { code: "+98", label: "IR" },
  { code: "+964", label: "IQ" },
  { code: "+353", label: "IE" },
  { code: "+972", label: "IL" },
  { code: "+39", label: "IT" },

  { code: "+81", label: "JP" },
  { code: "+962", label: "JO" },

  { code: "+7", label: "KZ" },
  { code: "+254", label: "KE" },
  { code: "+686", label: "KI" },
  { code: "+965", label: "KW" },
  { code: "+996", label: "KG" },

  { code: "+856", label: "LA" },
  { code: "+371", label: "LV" },
  { code: "+961", label: "LB" },
  { code: "+266", label: "LS" },
  { code: "+231", label: "LR" },
  { code: "+218", label: "LY" },
  { code: "+423", label: "LI" },
  { code: "+370", label: "LT" },
  { code: "+352", label: "LU" },

  { code: "+853", label: "MO" },
  { code: "+389", label: "MK" },
  { code: "+261", label: "MG" },
  { code: "+265", label: "MW" },
  { code: "+60", label: "MY" },
  { code: "+960", label: "MV" },
  { code: "+223", label: "ML" },
  { code: "+356", label: "MT" },
  { code: "+692", label: "MH" },
  { code: "+222", label: "MR" },
  { code: "+230", label: "MU" },
  { code: "+52", label: "MX" },
  { code: "+373", label: "MD" },
  { code: "+377", label: "MC" },
  { code: "+976", label: "MN" },
  { code: "+382", label: "ME" },
  { code: "+212", label: "MA" },
  { code: "+258", label: "MZ" },

  { code: "+264", label: "NA" },
  { code: "+674", label: "NR" },
  { code: "+977", label: "NP" },
  { code: "+31", label: "NL" },
  { code: "+64", label: "NZ" },
  { code: "+505", label: "NI" },
  { code: "+227", label: "NE" },
  { code: "+234", label: "NG" },
  { code: "+47", label: "NO" },

  { code: "+968", label: "OM" },

  { code: "+92", label: "PK" },
  { code: "+680", label: "PW" },
  { code: "+507", label: "PA" },
  { code: "+675", label: "PG" },
  { code: "+595", label: "PY" },
  { code: "+51", label: "PE" },
  { code: "+63", label: "PH" },
  { code: "+48", label: "PL" },
  { code: "+351", label: "PT" },

  { code: "+974", label: "QA" },

  { code: "+40", label: "RO" },
  { code: "+7", label: "RU" },
  { code: "+250", label: "RW" },

  { code: "+966", label: "SA" },
  { code: "+221", label: "SN" },
  { code: "+381", label: "RS" },
  { code: "+248", label: "SC" },
  { code: "+232", label: "SL" },
  { code: "+65", label: "SG" },
  { code: "+421", label: "SK" },
  { code: "+386", label: "SI" },
  { code: "+677", label: "SB" },
  { code: "+252", label: "SO" },
  { code: "+27", label: "ZA" },
  { code: "+82", label: "KR" },
  { code: "+34", label: "ES" },
  { code: "+94", label: "LK" },
  { code: "+249", label: "SD" },
  { code: "+597", label: "SR" },
  { code: "+46", label: "SE" },
  { code: "+41", label: "CH" },
  { code: "+963", label: "SY" },

  { code: "+886", label: "TW" },
  { code: "+992", label: "TJ" },
  { code: "+255", label: "TZ" },
  { code: "+66", label: "TH" },
  { code: "+228", label: "TG" },
  { code: "+676", label: "TO" },
  { code: "+216", label: "TN" },
  { code: "+90", label: "TR" },
  { code: "+993", label: "TM" },

  { code: "+256", label: "UG" },
  { code: "+380", label: "UA" },
  { code: "+971", label: "AE" },
  { code: "+44", label: "UK" },
  { code: "+1", label: "US" },
  { code: "+598", label: "UY" },
  { code: "+998", label: "UZ" },

  { code: "+678", label: "VU" },
  { code: "+58", label: "VE" },
  { code: "+84", label: "VN" },

  { code: "+967", label: "YE" },
  { code: "+260", label: "ZM" },
  { code: "+263", label: "ZW" },
];
